// removed by extract-text-webpack-plugin
module.exports = {"wrapper-pull-right":"wrapper-pull-right__3m-rw","table-pager":"table-pager__3VdJ5","pager-button":"pager-button__2OjkZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TablePagers/styles.scss
// module id = 2157
// module chunks = 1